/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveSimilarDocumentsRequest = {
  /**
   * The unique ID of the source document to find similar documents for
   */
  docId: string;
  /**
   * The name of the index containing the documents
   */
  indexName: string;
  /**
   * Maximum number of similar documents to return
   */
  limit?: number | undefined;
  /**
   * Optional metadata filter to apply to candidate documents
   */
  metadataFilter?: { [k: string]: any } | undefined;
};

/** @internal */
export const RetrieveSimilarDocumentsRequest$inboundSchema: z.ZodType<
  RetrieveSimilarDocumentsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  doc_id: z.string(),
  index_name: z.string(),
  limit: z.number().int().default(10),
  metadata_filter: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    "doc_id": "docId",
    "index_name": "indexName",
    "metadata_filter": "metadataFilter",
  });
});

/** @internal */
export type RetrieveSimilarDocumentsRequest$Outbound = {
  doc_id: string;
  index_name: string;
  limit: number;
  metadata_filter?: { [k: string]: any } | undefined;
};

/** @internal */
export const RetrieveSimilarDocumentsRequest$outboundSchema: z.ZodType<
  RetrieveSimilarDocumentsRequest$Outbound,
  z.ZodTypeDef,
  RetrieveSimilarDocumentsRequest
> = z.object({
  docId: z.string(),
  indexName: z.string(),
  limit: z.number().int().default(10),
  metadataFilter: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    docId: "doc_id",
    indexName: "index_name",
    metadataFilter: "metadata_filter",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace RetrieveSimilarDocumentsRequest$ {
  /** @deprecated use `RetrieveSimilarDocumentsRequest$inboundSchema` instead. */
  export const inboundSchema = RetrieveSimilarDocumentsRequest$inboundSchema;
  /** @deprecated use `RetrieveSimilarDocumentsRequest$outboundSchema` instead. */
  export const outboundSchema = RetrieveSimilarDocumentsRequest$outboundSchema;
  /** @deprecated use `RetrieveSimilarDocumentsRequest$Outbound` instead. */
  export type Outbound = RetrieveSimilarDocumentsRequest$Outbound;
}

export function retrieveSimilarDocumentsRequestToJSON(
  retrieveSimilarDocumentsRequest: RetrieveSimilarDocumentsRequest,
): string {
  return JSON.stringify(
    RetrieveSimilarDocumentsRequest$outboundSchema.parse(
      retrieveSimilarDocumentsRequest,
    ),
  );
}

export function retrieveSimilarDocumentsRequestFromJSON(
  jsonString: string,
): SafeParseResult<RetrieveSimilarDocumentsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RetrieveSimilarDocumentsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RetrieveSimilarDocumentsRequest' from JSON`,
  );
}
